import React, { Component, Ref } from "react";
import { _ReactPixi, Container, Graphics, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withCanvasAutoplayConfiguration from "./configuration/withCanvasAutoplayConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as autoplayActions } from "../../core/reducers/autoplayReducer";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
//import * as PIXI from "pixi.js";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as baseGameActions } from "../../core/reducers/baseGameReducer";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { configGame } from "../../data/config";
import { actions as reelsActions } from "../../core/reducers/reelsStateReducer";
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";
import { actions as reelgridActions } from "../../core/reducers/reelgridStateReducer";
import { Texture } from "pixi.js";
import { actions as behaviourAction } from "../../gamereducer/behaviourReducer";
import { actions as autoplayKeyboardListenerAction } from "../../gamereducer/autoplayKeyboardListenerReducer";
import { actions as reelsGridActions, actions as reelGridActions } from "../../core/reducers/reelgridStateReducer";
import * as PIXI from 'pixi.js';
import { TIMER } from "../../core/utills";
import 'pixi-text-input';
// import 'pixi-keyboard'; // side effect import
interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class CanvasAutoplay extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected canvasAutoplayContainer: any
    protected ui_mode: string;
    protected displayUI: any;
    protected data: any;
    protected dragging: any;
    protected x: any;
    protected y: any;
    protected parent: any;
    protected autoplayMainContainer: any;
    protected button1: number = this.props.autoplayList[0];
    protected button2: number = this.props.autoplayList[1];
    protected button3: number = this.props.autoplayList[2];
    protected button4: number = this.props.autoplayList[3];
    protected button5: number = this.props.autoplayList[4];
    protected button6: number = 40;
    protected button7: number = 50;
    protected button8: number = 75;
    protected button9: number = 100;
    protected storeLastClickedButtonValue: number = 0;
    protected sliderBarGraphicColor: any = 0xDE3249;
    protected sliderBarGraphicAlpha: any = 0.001;
    public valueOfSlider: number = 1;
    public initialXOfSliderDot: number = 400;
    public extraWidthValue: number = 9;
    protected valueMultiplierForFirstSlide: number = 500;
    protected valueMultiplierForSecondSlide: number = 5000;
    protected sliderLineHeight: number = 20;
    protected sliderLineY: number = 4;
    protected a: number = 0;
    public sliderDotName: any;
    public sliderLineName: any;
    public selectedInputName: any;
    public maxValue: any;
    public lastHighlightedButton: any;
    private betMulitiplier = [0, 5, 10, 20, 50]

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            buttonPanelEnable: true,
            allContainerList: [],
            autoplayModeOn: false,
            showOverLay: false,
            isSpinning: false,
            pause: false,
            play: true,
            basegameIdleMode: true,
            basegamePlayMode: false,
            uiElements: [],
            lang: "en",
            toggleOn: false,
            slideAlpha: 0
        }
        this.canvasAutoplayContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    selectMaxValue(dotName: any) {
        if (dotName === "sliderDot") {
            this.maxValue = (this.props.betList[this.props.currentBetIndex]) / 100 * this.valueMultiplierForFirstSlide;
        } else if (dotName === "sliderDot_2") {
            this.maxValue = (this.props.betList[this.props.currentBetIndex]) / 100 * this.valueMultiplierForSecondSlide;

        } else if (dotName === "sliderDot_3") {
            this.maxValue = this.props.transitionBalance;
        }
    }

    bindUI() {
        this.layoutChange(this.props.layoutMode);
        //this.addTextInputFields();
        this.setcanvasAutoplayContainerPosition()
    }

    setcanvasAutoplayContainerPosition() {
        if (this.props.showAutoplay) {
            let autoplayContainer = UIManager.getRef("canvasAutoplayContainer")
            autoplayContainer && (autoplayContainer.y = 55);
        }

    }

    rangeSlider(dotName: any, sliderName: any) {
        UIManager.getRef(dotName).on('pointerdown', this.onDragStart.bind(this))
            .on('pointerup', this.onDragEnd.bind(this))
            .on('pointerupoutside', this.onDragEnd.bind(this))
            .on('pointermove', this.onDragMove.bind(this, dotName, sliderName));

        //     UIManager.getRef("firstInputBoxGraphic").on('keydown', this.keyDown.bind(this))
        //         .on('keyup', this.keyDown.bind(this))
        //         .on('keyupoutside', this.keyDown.bind(this))
        //         .on('keymove', this.keyDown.bind(this, dotName, sliderName));
    }


    onDragStart(event: any) {
        this.sliderDotName = event.target.name;
        this.selectedInputName = event.target.name + '_inputBoxText';
        this.sliderLineName = event.target.name + 'Line';
        this.selectMaxValue(this.sliderDotName);
        this.data = event.data;
        this.dragging = true;
        this.x = this.data.global.x;
    }

    onDragEnd() {
        this.dragging = false;
        this.data = null;
    }

    onDragMove(dotName: any, sliderName: any) {

        if (this.dragging) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    slideAlpha: this.state.slideAlpha + 1
                }
            })
            const newPosition = this.data.global;
            if (newPosition.x < this.initialXOfSliderDot) {
                newPosition.x = this.initialXOfSliderDot;
            } else if (newPosition.x > (UIManager.getRef(sliderName).width - this.extraWidthValue) + this.initialXOfSliderDot) {
                newPosition.x = (UIManager.getRef(sliderName).width - this.extraWidthValue) + this.initialXOfSliderDot;
            }
            this.x = newPosition.x;
            UIManager.getRef(this.sliderDotName).x = newPosition.x;

            this.valueOfSlider = this.x - this.initialXOfSliderDot;
            let displayValue = 0;
            displayValue = this.maxValue / (UIManager.getRef(sliderName).width - this.extraWidthValue) * (this.valueOfSlider);

            if (this.sliderDotName == "sliderDot_3") {
                UIManager.setText(this.selectedInputName, (displayValue.toFixed(2)));
                if (displayValue > 0) {
                    this.props.setBalanceDecreasedBy((displayValue.toFixed(2)));
                }
            }
            else {
                UIManager.setText(this.selectedInputName, Math.round(displayValue));
                if (this.sliderDotName == "sliderDot") {
                    if (displayValue > 0) {
                        this.props.setSingleWinExceed(Math.round(displayValue));
                    }
                }
                if (this.sliderDotName == "sliderDot_2") {
                    if (displayValue > 0) {
                        this.props.setBalanceIncreasedBy(Math.round(displayValue));
                    }
                }
            }

        }



    }

    sliderBarVisibilityOnOff() {
        this.sliderBarVisibility("sliderDot", "sliderDotLine");
        this.sliderBarVisibility("sliderDot_2", "sliderDot_2Line");
        this.sliderBarVisibility("sliderDot_3", "sliderDot_3Line");
    }

    buttonModeOnForDots() {
        UIManager.getRef("sliderDot").buttonMode = true;
        UIManager.getRef("sliderDot_2").buttonMode = true;
        UIManager.getRef("sliderDot_3").buttonMode = true;
    }

    componentDidMount() {
        this.bindUI();
        if (this.props.showAutoplay) {

            UIManager.getRef("autoplay_StartButton").interactive = false;
            UIManager.getRef("autoplay_StartButton").texture = Texture.from("autoplay_down.png");
            this.buttonModeOnForDots();

            UIManager.getRef("sliderDot").x = this.initialXOfSliderDot;
            this.rangeSliderCall();
            this.sliderBarVisibilityOnOff();
            this.switchControl(this.props.handMode);
            //   if (this.props.stopAutoplayOnAnyWin) {
            //       // this.radioButtonClicked("radioButtonOff", "radioButtonOn");
            //       UIManager.getRef("radioButtonOff").visible = false;
            //       UIManager.getRef("radioButtonOn").visible = true;
            //   } else {
            //       //this.radioButtonClicked("radioButtonOn", "radioButtonOff");
            //       UIManager.getRef("radioButtonOff").visible = true;
            //       UIManager.getRef("radioButtonOn").visible = false;
            //   }
            // UIManager.getRef("radioButtonOnAnyWin").visible = this.props.stopAutoplayOnAnyWin;
            // UIManager.getRef("radioButtonOffOnAnyWin").visible = !this.props.stopAutoplayOnAnyWin;
            // UIManager.getRef("radioButtonOnOnFeature").visible = !this.props.stopAutoplayOnFreegame;
            // UIManager.getRef("radioButtonOffOnFeature").visible = this.props.stopAutoplayOnFreegame;
            let autoplay_StartButton = UIManager.getRef("autoplay_StartButton")
            autoplay_StartButton && (autoplay_StartButton.y = 909);
            //   UIManager.getRef("radioButtonOnOnFeature").visible = this.props.stopAutoplayOnFreegame;
            //   UIManager.getRef("radioButtonOffOnFeature").visible = !this.props.stopAutoplayOnFreegame;


            this.addInputTextFieldToContainers();
            this.setTextOfButons();
        }

    }


    setTextOfButons() {
        let arrayOfAutoplay = [];
        for (let i = 0; i < this.props.autoplayList.length; i++) {
            if (this.props.maximumAutoplay != 0) {
                if (this.props.autoplayList[i] <= this.props.maximumAutoplay) {
                    arrayOfAutoplay.push(this.props.autoplayList[i]);
                }
            } else {
                arrayOfAutoplay = this.props.autoplayList;
            }
        }
        if (arrayOfAutoplay.length < 5) {
            arrayOfAutoplay.splice(3, 0, arrayOfAutoplay[arrayOfAutoplay.length - 1] / 2)
        }

        for (let i = 1; i <= arrayOfAutoplay.length; i++) {
            if (i == 1) {
                this.button1 = arrayOfAutoplay[i - 1]
            }
            if (i == 2) {
                this.button2 = arrayOfAutoplay[i - 1]
            }
            if (i == 3) {
                this.button3 = arrayOfAutoplay[i - 1]
            }
            if (i == 4) {
                this.button4 = arrayOfAutoplay[i - 1]
            }
            if (i == 5) {
                this.button5 = arrayOfAutoplay[i - 1]
            }
            // if (i == arrayOfAutoplay.length) {

            //     if (this.props.maximumAutoplay == 0) {
            //         UIManager.getRef("autoplayButton" + i).children[0].text = arrayOfAutoplay[i - 1];
            //     }
            //     else {
            //         UIManager.getRef("autoplayButton" + i).children[0].text = this.props.maximumAutoplay;
            //     }
            // }
            // else {
            //     UIManager.getRef("autoplayButton" + i).children[0].text = arrayOfAutoplay[i - 1];
            // }
            UIManager.getRef("autoplayButton" + i).children[0].text = arrayOfAutoplay[i - 1];


        }
    }

    componentDidUpdate() {
        if (this.props.showAutoplay) {
            let autoplay_StartButton = UIManager.getRef("autoplay_StartButton")
            autoplay_StartButton && (autoplay_StartButton.y = 909);
            // this.setTextOfButons();
        }
    }

    addInputTextFieldToContainers() {
        let lossLimitContainer = UIManager.getRef("lossLimit__Container");
        if (lossLimitContainer) {
            this.addTextInputFields(lossLimitContainer, 624, 270);
        }

        let winLimitContainer = UIManager.getRef("winLimit__Container");
        if (winLimitContainer) {
            this.addTextInputFields(winLimitContainer, 624, 270);
        }

        let singleWinLimitContainer = UIManager.getRef("singleWinLimit__Container");
        if (singleWinLimitContainer) {
            this.addTextInputFields(singleWinLimitContainer, 655, 270);
        }
    }

    rangeSliderCall() {
        this.rangeSlider("sliderDot", "sliderDotLine");
        this.rangeSlider("sliderDot_2", "sliderDot_2Line");
        this.rangeSlider("sliderDot_3", "sliderDot_3Line");
    }

    sliderBarVisibilityForInput(sliderDot: any, sliderLine: any) {
        const thing = new PIXI.Graphics();
        thing.beginFill(this.sliderBarGraphicColor);
        thing.drawRect(0, this.sliderLineY, UIManager.getRef(sliderDot).x - this.initialXOfSliderDot, this.sliderLineHeight);
        thing.endFill();
        UIManager.getRef(sliderLine).addChild(thing);
        thing.x = 0;
        thing.y = 0;
        thing.alpha = this.sliderBarGraphicAlpha;
        UIManager.getRef(sliderLine).mask = thing;

    }

    sliderBarVisibility(sliderDot: any, sliderLine: any) {
        const thing = new PIXI.Graphics();
        thing.beginFill(this.sliderBarGraphicColor);
        thing.drawRect(0, this.sliderLineY, UIManager.getRef(sliderDot).x - this.initialXOfSliderDot, this.sliderLineHeight);
        thing.endFill();
        UIManager.getRef(sliderLine).addChild(thing);
        thing.x = 0;
        thing.y = 0;
        thing.alpha = this.sliderBarGraphicAlpha;
        UIManager.getRef(sliderLine).mask = thing;

    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.layoutMode !== this.props.layoutMode) {
            this.layoutChange(nextProps.layoutMode)
            return false;
        }

        if (nextProps.autoplayCount !== this.props.autoplayCount) {
            if (nextProps.autoplayCount == 0) {
                this.props.setBalanceIncreasedBy(-1);
                this.props.setBalanceDecreasedBy(-1);
                this.props.setSingleWinExceed(-1);
            }
            return false;
        }

        if (nextState.slideAlpha !== this.state.slideAlpha) {
            this.sliderBarVisibility(this.sliderDotName, this.sliderLineName);
            return false;
        }

        if (nextProps.handMode !== this.props.handMode) {
            this.switchControl(nextProps.handMode)
        }

        if (nextProps.digitToDisplay !== this.props.digitToDisplay) {

            /* if (nextProps.clickedInputBox == "inputBox_1") {

                this.x = nextProps.digitToDisplay - this.initialXOfSliderDot;
                UIManager.setText("sliderDot_inputBoxText", "");
                UIManager.setText("sliderDot_inputBoxText", nextProps.digitToDisplay);

                if (nextProps.digitToDisplay > 0) {
                    this.props.setSingleWinExceed(Math.floor(nextProps.digitToDisplay));
                }

            }
            else if (nextProps.clickedInputBox == "inputBox_2") {
                UIManager.setText("sliderDot_2_inputBoxText", "");
                UIManager.setText("sliderDot_2_inputBoxText", nextProps.digitToDisplay);
                if (nextProps.digitToDisplay > 0) {
                    this.props.setBalanceIncreasedBy(Math.floor(nextProps.digitToDisplay));
                }
            }

            else if (nextProps.clickedInputBox == "inputBox_3") {
                UIManager.setText("sliderDot_3_inputBoxText", "");
                UIManager.setText("sliderDot_3_inputBoxText", nextProps.digitToDisplay);
                if (nextProps.digitToDisplay > 0) {
                    this.props.setBalanceDecreasedBy((nextProps.digitToDisplay.toFixed(2)));
                }
            } */
            return false;
        }

        return false;
    }

    switchControl(handMode: any) {
        let autoStartBtn = UIManager.getRef("autoplay_StartButton");
        if (autoStartBtn) {
            if (handMode === 'right') {
                autoStartBtn.x = 1684;
                autoStartBtn.y = 964;
            } else {
                autoStartBtn.x = 155;
                autoStartBtn.y = 964;
            }
        }
    }

    onClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("autoplayButton1").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("autoplayButton2").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("autoplayButton3").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("autoplayButton4").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("autoplayButton5").texture = Texture.from("autoplay_btn_up.png");


        e.target.texture = Texture.from("autoplay_btn_over.png");
        UIManager.getRef("autoplay_StartButton").interactive = true;
        this.props.setValueOfNumberButton(value - 1);
        this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
    }

    onLossLimitClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("LossLimitBtn1").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("LossLimitBtn2").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("LossLimitBtn3").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("LossLimitBtn4").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("LossLimitBtn5").texture = Texture.from("autoplay_btn_up.png");

        e.target.texture = Texture.from("autoplay_btn_over.png");
        //UIManager.getRef("autoplay_StartButton").interactive = true;
        //this.props.setValueOfNumberButton(value - 1);
        // this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
        let displayValue = this.props.coinList[this.props.selectedCoin] * value
        UIManager.getRef('lossLimit__Container').getChildByName("lossLimit__Container_text_field").text = displayValue.toFixed(2)
        //UIManager.setText("lossLimit__Container_text_field", displayValue.toFixed(2));
        this.props.setBalanceDecreasedBy((displayValue));
    }
    onWinLimitClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("winLimitBtn1").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("winLimitBtn2").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("winLimitBtn3").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("winLimitBtn4").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("winLimitBtn5").texture = Texture.from("autoplay_btn_up.png");


        e.target.texture = Texture.from("autoplay_btn_over.png");
        //UIManager.getRef("autoplay_StartButton").interactive = true;
        //this.props.setValueOfNumberButton(value - 1);
        //this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
        let displayValue = this.props.coinList[this.props.selectedCoin] * value
        //UIManager.setText("sliderDot_2_inputBoxText", displayValue.toFixed(2));
        UIManager.getRef('winLimit__Container').getChildByName("winLimit__Container_text_field").text = displayValue.toFixed(2)

        this.props.setBalanceIncreasedBy(Math.floor(displayValue));
    }

    singleWinLimitClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("singleWinLimitBtn1").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("singleWinLimitBtn2").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("singleWinLimitBtn3").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("singleWinLimitBtn4").texture = Texture.from("autoplay_btn_up.png");
        UIManager.getRef("singleWinLimitBtn5").texture = Texture.from("autoplay_btn_up.png");

        e.target.texture = Texture.from("autoplay_btn_over.png");
        //UIManager.getRef("autoplay_StartButton").interactive = true;
        //this.props.setValueOfNumberButton(value - 1);
        //this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
        let displayValue = this.props.coinList[this.props.selectedCoin] * value

        UIManager.getRef('singleWinLimit__Container').getChildByName("singleWinLimit__Container_text_field").text = displayValue.toFixed(2)
        this.props.setSingleWinExceed(Math.floor(displayValue));
    }

    disableSelectedButton(parentName: any) {
        switch (parentName) {
            case 'winLimit__Container':
                UIManager.getRef("winLimitBtn1").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("winLimitBtn2").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("winLimitBtn3").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("winLimitBtn4").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("winLimitBtn5").texture = Texture.from("autoplay_btn_up.png");
                this.props.setBalanceIncreasedBy(0);
                break;
            case 'singleWinLimit__Container':
                UIManager.getRef("singleWinLimitBtn1").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("singleWinLimitBtn2").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("singleWinLimitBtn3").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("singleWinLimitBtn4").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("singleWinLimitBtn5").texture = Texture.from("autoplay_btn_up.png");

                this.props.setSingleWinExceed(0);
                break;
            case 'lossLimit__Container':
                UIManager.getRef("LossLimitBtn1").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("LossLimitBtn2").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("LossLimitBtn3").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("LossLimitBtn4").texture = Texture.from("autoplay_btn_up.png");
                UIManager.getRef("LossLimitBtn5").texture = Texture.from("autoplay_btn_up.png");
                this.props.setBalanceDecreasedBy(0);
                break;
        }

    }

    setLimitOnFocusOut(parentName: any, value: any) {
        if (value > 0) {
            switch (parentName) {
                case 'winLimit__Container':
                    UIManager.getRef('winLimit__Container').getChildByName("winLimit__Container_text_field").text = value.toFixed(2)
                    this.props.setBalanceIncreasedBy(value);
                    break;
                case 'singleWinLimit__Container':
                    UIManager.getRef('singleWinLimit__Container').getChildByName("singleWinLimit__Container_text_field").text = value.toFixed(2)
                    this.props.setSingleWinExceed(value);
                    break;
                case 'lossLimit__Container':
                    UIManager.getRef('lossLimit__Container').getChildByName("lossLimit__Container_text_field").text = value.toFixed(2)
                    this.props.setBalanceDecreasedBy(value);
                    break;
            }
        }

    }

    addTextInputFields(parent: any, XPos: any, Ypos: any) {
        const TextInput = require('pixi-text-input')
        let inputTxtField = new TextInput({
            input: {
                fontFamily: 'Arial',
                fontSize: '20px',
                padding: '14px 24px',
                width: '140px',
                color: 'white',
                height: '35px'
            },
            box: this.generateBox
        })

        //inputTxtField.placeholder = 'Enter your Text...'
        inputTxtField.name = parent.name + "_text_field"
        inputTxtField.x = XPos
        inputTxtField.y = Ypos
        var reg = /^\d+$/;
        inputTxtField.restrict = reg;

        let parentContainer = parent
        if (parentContainer) {
            parentContainer.addChild(inputTxtField)
            inputTxtField.on('keydown', (keycode: any) => {

                if (keycode >= 96 && keycode <= 105) {


                    //inputTxtField.text = keycode
                    if (Number(inputTxtField.text) > this.props.coinList[this.props.selectedCoin] * 50) {

                    }
                } else {
                    keycode = ""
                }

            })

            inputTxtField.on('focus', (keycode: any) => {
                this.disableSelectedButton(parentContainer.name)

            })
            inputTxtField.on('blur', (keycode: any) => {
                //Number(inputTxtField.text).toFixed(2)
                this.setLimitOnFocusOut(parentContainer.name, Number(inputTxtField.text));

            })
        }
    }



    generateBox(w: any, h: any, state: any) {
        var box = new PIXI.Container()
        var sprite = UIManager.getRef('generateBoxFrame')
        var mask = new PIXI.Graphics()
        mask.beginFill(0x181818)
        mask.drawRect(0, 0, w, h)
        box.addChild(mask)
        if (sprite) {
            box.addChild(sprite)
            sprite.mask = mask

            switch (state) {
                case 'DEFAULT':
                    sprite.tint = 0xffffff
                    break;
                case 'FOCUSED':
                    sprite.tint = 0x7EDFFF
                    break;
                case 'DISABLED':
                    sprite.alpha = 0.5
                    break;
            }
        }

        return box
    }

    radioButtonClickedOnWin(currentButtonName: any, nextButtonName: any) {
        this.props.stoppedAutoplayOnWin();
        UIManager.getRef("radioButtonOnAnyWin").visible = this.props.stopAutoplayOnAnyWin;
        UIManager.getRef("radioButtonOffOnAnyWin").visible = !this.props.stopAutoplayOnAnyWin;
    }
    radioButtonClickedOnFeature(currentButtonName: any, nextButtonName: any) {
        this.props.stoppedAutoplayOnFreeGame();
        UIManager.getRef("radioButtonOnOnFeature").visible = this.props.stopAutoplayOnFreegame;
        UIManager.getRef("radioButtonOffOnFeature").visible = !this.props.stopAutoplayOnFreegame;
    }

    handleEvent = (e: any) => {
        UIManager.getRef("autoplay_StartButton").texture = Texture.from("autoplay_down.png");

        switch (e.target.name) {
            case "autoplayButton1":
                this.onClick(e, e.target.name, this.button1);
                return;
            case "autoplayButton2":
                this.onClick(e, e.target.name, this.button2);
                return;
            case "autoplayButton3":
                this.onClick(e, e.target.name, this.button3);
                return;
            case "autoplayButton4":
                this.onClick(e, e.target.name, this.button4);
                return;
            case "autoplayButton5":

                // if (this.props.maximumAutoplay !== 0) {
                //     this.button5 = this.props.maximumAutoplay;
                // }


                this.onClick(e, e.target.name, this.button5);
                return;
            case "LossLimitBtn1":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[0]);
                return;
            case "LossLimitBtn2":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[1]);
                return;
            case "LossLimitBtn3":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[2]);
                return;
            case "LossLimitBtn4":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[3]);
                return;
            case "LossLimitBtn5":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[4]);
                return;
            case "winLimitBtn1":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[0]);
                return;
            case "winLimitBtn2":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[1]);
                return;
            case "winLimitBtn3":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[2]);
                return;
            case "winLimitBtn4":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[3]);
                return;
            case "winLimitBtn5":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[4]);
                return;
            case "singleWinLimitBtn1":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[0]);
                return;
            case "singleWinLimitBtn2":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[1]);
                return;
            case "singleWinLimitBtn3":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[2]);
                return;
            case "singleWinLimitBtn4":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[3]);
                return;
            case "singleWinLimitBtn5":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[4]);
                return;

            case "radioButtonOnAnyWin":
                this.radioButtonClickedOnWin("radioButtonOnAnyWin", "radioButtonOffOnAnyWin");
                return;
            case "radioButtonOffOnAnyWin":
                this.radioButtonClickedOnWin("radioButtonOffOnAnyWin", "radioButtonOnAnyWin");
                return;
            case "radioButtonOnOnFeature":
                this.radioButtonClickedOnFeature("radioButtonOnOnFeature", "radioButtonOffOnFeature");
                return;
            case "radioButtonOffOnFeature":
                this.radioButtonClickedOnFeature("radioButtonOffOnFeature", "radioButtonOnOnFeature");
                return;

            case "autoplay_StartButton":
                this.startAutoplay();
                return;
            case "autoplay_CancelButton":
                this.props.setAutoplayKeyboardListenerActive(false);
                this.props.setAllButtonEnable();
                this.props.hideAutoplay();
                //this.props.setDigitToDisplay(0);
                return;
            /*  case "inputBox_1":
                 this.props.setAutoplayKeyboardListenerActive(true);
                 this.props.setNameOfClickedInputBox("inputBox_1");
                 return;
             case "inputBox_2":
                 this.props.setAutoplayKeyboardListenerActive(true);
                 this.props.setNameOfClickedInputBox("inputBox_2");
                 return;
             case "inputBox_3":
                 this.props.setAutoplayKeyboardListenerActive(true);
                 this.props.setNameOfClickedInputBox("inputBox_3");
                 return; */
            default:
                return 'No buttons';
        }
    }

    startAutoplay() {
        if (this.props.balance - this.props.coinList[this.props.selectedCoin] < 0) {
            this.props.setInsufficientFunds(true);
            this.props.setAutoplayKeyboardListenerActive(false);
            this.props.setAllButtonEnable();
            this.props.hideAutoplay();
        }
        else {
            this.props.setAmountForAutoplay(Number(this.props.balance));
            this.props.hideAutoplay();
            // this.props.setAutoplayKeyboardListenerActive(false);
            this.props.setAutoplay(this.props.numberButtonValue);
            this.props.setApplicationAutoplayCount(this.props.numberButtonValue);
            this.props.startAutoplay();
            this.props.getApplicationSpinResponse();
            this.props.stopWinPresentation();
            this.props.resetReelState();
            this.props.setAllButtonDisable();
            this.props.interactivityOfStartButton(false);


            if (Number(configGame["SPIN_TYPE"]) === 0) {
                const {
                    startSpin
                } = this.props;
                startSpin();
            } else if (Number(configGame["SPIN_TYPE"]) === 2) {
                const {
                    startRGSpin
                } = this.props;
                startRGSpin();
            } else {
                const {
                    startGridSpin
                } = this.props;
                startGridSpin();
            }
        }
    }


    onClickValueChange(e: any, sliderDot: any, sliderLine: any, inputBoxValue: any) {
        this.data = e.data;
        this.x = this.data.global.x - this.initialXOfSliderDot;
        UIManager.getRef(sliderDot).x = this.x + this.initialXOfSliderDot - this.extraWidthValue;

        let displayValue = 0;
        this.selectMaxValue(sliderDot);
        if (sliderDot == "sliderDot_3") {
            displayValue = this.maxValue / (UIManager.getRef("sliderLineBG").width - this.extraWidthValue) * (this.x);

        }
        else {
            displayValue = this.maxValue / (UIManager.getRef("sliderLineBG").width - this.extraWidthValue) * Math.floor(this.x);

        }
        if (displayValue > this.maxValue) {
            displayValue = this.maxValue;
        }
        if (sliderDot == "sliderDot_3") {
            UIManager.setText(inputBoxValue, displayValue.toFixed(2));
            if (displayValue > 0) {
                this.props.setBalanceDecreasedBy((displayValue.toFixed(2)));
            }
        }
        else {
            UIManager.setText(inputBoxValue, Math.floor(displayValue));
            if (sliderDot == "sliderDot") {
                if (displayValue > 0) {
                    this.props.setSingleWinExceed(Math.floor(displayValue));
                }
            }
            if (sliderDot == "sliderDot_2") {
                if (displayValue > 0) {
                    this.props.setBalanceIncreasedBy(Math.floor(displayValue));
                }
            }
        }

    }

    mouseOver() {
        //alert("mouseOver")
    }

    mouseOut = (e: any) => {

        /*  switch (e.currentTarget.name) {
             case "inputBox_1":
                 this.props.setAutoplayKeyboardListenerActive(false);
                 return;
             case "inputBox_2":
                 this.props.setAutoplayKeyboardListenerActive(false);
                 return;
             case "inputBox_3":
                 this.props.setAutoplayKeyboardListenerActive(false);
                 return;
 
             default:
                 return 'No buttons';
         } */
    }


    render() {
        if (!this.props.showAutoplay) {
            return (<></>)
        }
        return (
            <UIManager id={"canvasAutoplayContainer"} type={"Container"} ref={i => this.canvasAutoplayContainer = i} name={"canvasAutoplayContainer"}
                configGame={this.props.configGame}
                app={this.app}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                            ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut} scope={this} />
                    )
                }
            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'wrapperState' | 'autoplayState' | 'betPanelState' | 'applicationState' | 'basegameState' | 'behaviourState' | 'autoplayKeyBoardListenerState'>): IStateToProps =>
    ({
        showAutoplay: state.autoplayState.showAutoplay,
        autoplayCount: state.basegameState.autoplayCount,
        balance: state.basegameState.balance,
        currentBetIndex: state.basegameState.currentBetIndex,
        betList: state.basegameState.betList,
        numberButtonValue: state.autoplayState.numberButtonValue,
        stopAutoplayOnAnyWin: state.autoplayState.stopAutoplayOnAnyWin,
        stopAutoplayOnFreegame: state.autoplayState.stopAutoplayOnFreegame,
        transitionBalance: state.behaviourState.transitionBalance,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,
        handMode: state.applicationState.handMode,
        digitToDisplay: state.autoplayKeyBoardListenerState.digitToDisplay,
        clickedInputBox: state.autoplayKeyBoardListenerState.clickedInputBox,
        autoplayList: state.behaviourState.autoplayList,
        maximumAutoplay: state.wrapperState.maximumAutoplay,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        startSpin: (): any => dispatch(reelsActions.startSpin()),
        startRGSpin: (): any => dispatch(reelGridActions.startSpin()),
        startGridSpin: (): any => dispatch(gridsActions.startSpin()),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setValueOfNumberButton: (numberButtonValue: number): any => dispatch(autoplayActions.setValueOfNumberButton(numberButtonValue)),
        interactivityOfStartButton: (startButtonInteractivity: boolean): any => dispatch(autoplayActions.interactivityOfStartButton(startButtonInteractivity)),
        stoppedAutoplayOnWin: (): any => dispatch(autoplayActions.stoppedAutoplayOnWin()),
        stoppedAutoplayOnFreeGame: (): any => dispatch(autoplayActions.stoppedAutoplayOnFreeGame()),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        hideAutoplay: (): any => dispatch(autoplayActions.hideAutoplayUI()),
        setAutoplay: (autoplayCount: number): any => dispatch(autoplayActions.setAutoplayCount(autoplayCount)),
        startAutoplay: (): any => dispatch(baseGameActions.startAutoplay()),
        setApplicationAutoplayCount: (autoplaycount: number): any => dispatch(baseGameActions.setApplicationAutoplayCount(autoplaycount)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        resetReelState: (): any => dispatch(Number(configGame["SPIN_TYPE"]) === 0 && reelsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 1 && gridsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 2 && reelgridActions.resetReelState()),
        autoplayReset: (resetAutoplay: boolean): any => dispatch(autoplayActions.autoplayReset(resetAutoplay)),
        setBalanceIncreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceIncreasedBy(value)),
        setBalanceDecreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceDecreasedBy(value)),
        setSingleWinExceed: (value: any): any => dispatch(autoplayActions.setSingleWinExceed(value)),
        setAmountForAutoplay: (storeAmountForAutoplay: any): any => dispatch(behaviourAction.setAmountForAutoplay(storeAmountForAutoplay)),
        setAutoplayKeyboardListenerActive: (autoplayKeyboardListenerActive: boolean): any => dispatch(autoplayKeyboardListenerAction.setAutoplayKeyboardListenerActive(autoplayKeyboardListenerActive)),
        setNameOfClickedInputBox: (clickedInputBox: any): any => dispatch(autoplayKeyboardListenerAction.setNameOfClickedInputBox(clickedInputBox)),
        setDigitToDisplay: (digitToDisplay: any): any => dispatch(autoplayKeyboardListenerAction.setDigitToDisplay(digitToDisplay)),
        setInsufficientFunds: (insuffFunds: any): any => dispatch(behaviourAction.setInsufficientFunds(insuffFunds)),
    }))(withCanvasAutoplayConfiguration(CanvasAutoplay)));